import { createContext, useEffect, useState } from "react";

const ToastContext = createContext();
export default ToastContext;

export const ToastContextProvider = ({ children }) => {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);

  // Auto-hide logic
  useEffect(() => {
    if (!toast) return;

    setVisible(true);

    const timer = setTimeout(() => setVisible(false), 4000);
    const removeTimer = setTimeout(() => setToast(null), 4500);

    return () => {
      clearTimeout(timer);
      clearTimeout(removeTimer);
    };
  }, [toast]);

  const show = (msg, className) => {
    setToast({ msg, className });
  };

  const success = msg => show(msg, "success");
  const error = msg => show(msg, "danger");
  const warning = msg => show(msg, "warning");
  const info = msg => show(msg, "info");

  const notification = { success, error, warning, info };

  return (
    <ToastContext.Provider value={notification}>
      {children}

      {toast && (
        <div
          className={`fixed left-1/2 lg:left-[unset] lg:right-0 -translate-x-1/2 bottom-[5rem] lg:bottom-[unset] lg:top-[5rem] z-[9999]
            px-4 py-3 w-[90%] max-w-[420px]
            rounded-xl shadow-lg text-white 
            transition-all duration-300
            ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
            ${toast.className === "success" ? "bg-card" : ""}
            ${toast.className === "danger" ? "bg-red-600" : ""}
            ${toast.className === "warning" ? "bg-yellow-600" : ""}
            ${toast.className === "info" ? "bg-blue-600" : ""}
          `}
        >
          {toast.msg}
        </div>
      )}
    </ToastContext.Provider>
  );
};
